import { Component, ElementRef } from '@angular/core';
import { NavController } from 'ionic-angular';
import { HomePage } from '../../pages/home/home';
import { DesktopService } from '../../providers/desktop-service';
import { BlankDesktopPage } from "../../pages/desktop/blank/blank";


@Component({
    selector: 'desktop-header',
    templateUrl: 'desktop-header.html',
})
export class DesktopHeaderComponent {

    public canGoHome: boolean = false;
    public isDesktop: boolean = false;
    public element: HTMLElement = null;

    constructor(
        private desktop: DesktopService,
        private elementRef: ElementRef,
        private navCtrl: NavController,
    ) {

    }

    public ngOnInit() {
        let active = this.navCtrl.getActive();
        let instance = active.instance;
        this.canGoHome = !( instance instanceof HomePage );
        this.element = this.elementRef.nativeElement;
        this.isDesktop = this.desktop.isDesktop();

        if (!this.isDesktop) this.element.classList.add('hidden');
    }

    public goHome() {
        if (!this.canGoHome) return;
        this.navCtrl.setRoot(HomePage, {}, {
            animate: true,
            direction: 'back'
        });
        this.desktop.getRightPane().setRoot(BlankDesktopPage, {}, {
            animate: false,
        });
    }

}



// WEBPACK FOOTER //
// ./src/components/desktop-header/desktop-header.ts